<div class="desktop">
    <ng-container *ngIf="!esUnSoloDia; else unSoloDia">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <p class="txt-agenda-dia">Agenda el día de la entrega e instalación de tu equipo</p>
        </div>
        <div>
            <a class="carousel-prev" role="button" data-slide="prev" (click)="semanaPrevia()">
                <!-- <span *ngIf="enablePrev" class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span *ngIf="!enablePrev" class="carousel-control-prev-icon-dis" aria-hidden="true"></span> -->
                <img *ngIf="enablePrev" src="assets/icons/prev-agenda-on.png" class="carousel-control-prev-icon" alt="prev-agenda-on">
                <img *ngIf="!enablePrev" src="assets/icons/prev-agenda-off.png" class="carousel-control-prev-icon-dis notification-counter" alt="prev-agenda-off" 
                    [class.disabled]="!enablePrev">
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-next" role="button" data-slide="next" (click)="semanaSiguiente()">
                <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
                <!-- <span [ngClass]="{'carousel-control-next-icon': enableNext, 'carousel-control-next-icon-dis': !enableNext}" aria-hidden="true"></span> -->
                <img *ngIf="enableNext" src="assets/icons/next-agenda-on.png" class="carousel-control-next-icon" alt="next-agenda-on">
                <img *ngIf="!enableNext" src="assets/icons/next-agenda-off.png" class="carousel-control-next-icon-dis notification-counter" alt="next-agenda-off" 
                    [class.disabled]="!enableNext">
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    </ng-container>

    <app-messages *ngIf="esDespachoCourier" class="informativoCourier mb-16 p-16"
        message='<strong>Despacho gratis programado:</strong> Entre <strong>08:00 a 18:00 hrs.</strong> según disponibilidad de entrega basada en tu dirección actual.'>
    </app-messages>
    <app-messages *ngIf="esInstalacionTecnico" class="informativoTecnico mb-16 p-16"
        message='<strong>Instalación gratis programada:</strong> Entre <strong>10:00 a 22:00 hrs.</strong> según disponibilidad basada en tu dirección actual.'>
    </app-messages>

    <ng-template #unSoloDia>
        <div class="d-flex">
            <button class="box-dia extremo">
                <p class="txt-dia-nombre">{{arregloFechas.nombreDia}}</p>
                <p class="txt-dia-numero">{{arregloFechas.dia}}</p>
                <p class="txt-dia-nombre">{{arregloFechas.nombreMes}}</p>
            </button>
    
            <div class="box-extrema">
    
                <p class="content-tooltip">Para tu localidad hemos encontrado una fecha para ti</p>
            </div>
        </div>
    </ng-template>


    <div id="carouselAgenda" class="carousel slide" data-interval="false" data-wrap="false" *ngIf="true">
        <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
                <button *ngFor="let fechaDespacho of fechasDespacho; let i = index" (click)="changeFecha(i)" 
                        class="carousel-item box-dia active" type="button" data-container="body" 
                        data-toggle="tooltip" data-placement="bottom" 
                        [ngClass]="{'focus': fechaDespacho.default}"
                        [disabled]="loading"
                        data-content="¿Te parece esta fecha? hemos seleccionado la fecha más próxima para ti, si no tienes disponibilidad, puedes elegir otro día.">
                    <p class="txt-dia-nombre">{{fechaDespacho.nombreDia}}</p>
                    <p class="txt-dia-numero">{{fechaDespacho.dia}}</p>
                    <p class="txt-dia-nombre">{{fechaDespacho.nombreMes}}</p>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="box-tooltip" *ngIf="showToolTip">
    <p class="title-tooltip"> <strong>¿Te parece esta fecha?</strong></p>
    <p class="content-tooltip">Hemos seleccionado la fecha más próxima para ti, si no tienes disponibilidad <strong>puedes elegir otro día</strong>.</p>
</div>


<div class="mobile calendar">
    <div>
        <p class="txt-agenda-dia">Agenda el día de la entrega e instalación de tu equipo</p>
    </div>

    <app-messages *ngIf="esDespachoCourier" class="informativoCourier mb-16 p-16"
        message='<strong>Despacho gratis programado:</strong> Entre <strong>08:00 a 18:00 hrs.</strong> según disponibilidad de entrega basada en tu dirección actual.'>
    </app-messages>
    <app-messages *ngIf="esInstalacionTecnico" class="informativoTecnico mb-16 p-16"
        message='<strong>Instalación gratis programada:</strong> Entre <strong>10:00 a 22:00 hrs.</strong> según disponibilidad basada en tu dirección actual.'>
    </app-messages>

    <ng-container *ngIf="!esUnSoloDia; else unSoloDia">
        <ul>
            <li *ngFor="let fechaDespacho of fechasDespacho; let i = index">
                <button class="box-dia" [ngClass]="{'focus': fechaDespacho.default}" (click)="changeFecha(i)" [disabled]="loading">
                    <p class="txt-dia-nombre">{{fechaDespacho.nombreDia}}</p>
                    <p class="txt-dia-numero">{{fechaDespacho.dia}}</p>
                    <p class="txt-dia-nombre">{{fechaDespacho.nombreMes}}</p>
                </button>
            </li>
        </ul>
    </ng-container>
</div>